import { Swiper, Autoplay } from 'swiper';

export default {
  init() {

    /**************************************************************
    -> Open/close profile lightboxes
    **************************************************************/
    // function triggerProfileLightbox() {
    //   const buttonContainers = Array.from(Array.from(document.querySelectorAll('[data-button-lightbox-bio]')))
      
    //   buttonContainers.forEach(container => {
    //     const button = container.querySelector('button')
    //     const index = container.dataset.index
    
    //     button.addEventListener('click', () => {
    //       const lightbox = document.querySelector(`[data-lightbox-profile][data-index="${index}"]`)
    //       const lightboxContainer = lightbox.querySelector('[data-container]')
    //       const closeTriggers = Array.from(lightbox.querySelectorAll('[data-lightbox-close]'))
          
    //       document.body.style.overflow = 'hidden'
    //       gsap.to(lightbox, { opacity: 1, pointerEvents: 'all', delay: 0.3})
    //       gsap.to(lightboxContainer, { y: 0, delay: 0.3 })
          
    //       closeTriggers.forEach(close => {
    //         close.addEventListener('click', () => {
    //           document.body.style.overflow = 'initial'
    //           gsap.to(lightbox, { opacity: 0, pointerEvents: 'none' })
    //           gsap.to(lightboxContainer, { y: '25px' })
    //         })
    //       })
    //     })
    //   })
    // }
    
    // triggerProfileLightbox()

    Swiper.use([Autoplay]);
    
    /**************************************************************
    -> Publication Swiper instance
    **************************************************************/
    function locationsSwiper() {
      new Swiper('.locations .swiper-container', {
        spaceBetween: 20,
        slidesPerView: 'auto',
        autoplay: {
           delay: 5000,
        },
        breakpoints: {
            769: {
              slidesPerView: 3,
            },
         },
      })

    }

    locationsSwiper()

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/template-collect.js